import { markdownToPlainText } from "./markdown-plain-text";

/** Keep the question and its visible choices in one cancellable utterance. */
export function questionSpeechText(
  question: string,
  options: ReadonlyArray<{ label: string }>,
): string {
  const prompt = plainText(question);
  if (!prompt) return "";
  const labels = options
    .map((option) => plainText(option.label))
    .filter(Boolean);
  if (!labels.length) return prompt;
  return [
    sentence(prompt),
    ...labels.map((label, index) => `Option ${index + 1}: ${sentence(label)}`),
  ].join(" ");
}

function plainText(text: string): string {
  return markdownToPlainText(text).replace(/\s+/g, " ").trim();
}

function sentence(text: string): string {
  return /[.!?…][)"'”’]*$/.test(text) ? text : `${text}.`;
}
